import { render } from "./EditLoyerModal.vue?vue&type=template&id=38eb8a46"
import script from "./EditLoyerModal.vue?vue&type=script&lang=js"
export * from "./EditLoyerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__